import React, { useEffect, useState, useContext, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoCaretUpOutline, IoCaretDownOutline, IoVolumeHigh } from 'react-icons/io5';
import Select from 'react-select';
import config from "../../envconfig";
import { UserContext } from '../common/UserContext';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer, toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import ReactSelectDropDown from '../common/ReactSelectDropDown';
import StatusCustomDropdown from '../common/StatusCustomDropdown';
import { set } from 'date-fns';
import CustomSingleValue from '../common/CustomSingleValue';

function UserMaster() {
    const location = useLocation();
    const allowedCountries = ['in', 'af', 'dz', 'au', 'at', 'be', 'us']; // ISO country codes
    const [channelValues, setChannelValues] = useState([]);
    const [resetCounter, setResetCounter] = useState(0);
    const phoneNumberToCountryCode = (dialCode) => {
        dialCode = String(dialCode); // 👈 Fix here
        switch (dialCode) {
            case '91': return 'in';
            case '1': return 'us';
            case '93': return 'af';
            case '213': return 'dz';
            case '61': return 'au';
            case '43': return 'at';
            case '32': return 'be';
            default: return undefined;
        }
    };



    const phoneLengthMapping = {
        "91": 10,
        "93": 9,
        "213": 9,
        "61": 9,
        "43": 10,
        "32": 9,
        "1": 10,
    };
    const [phoneNumberCountry, setPhoneNumberCountry] = useState('91');

    const phoneInitialized = useRef(false);
    const [editDataState, setEditDataState] = useState(() => {
        const storedData = localStorage.getItem("user");
        return storedData ? JSON.parse(storedData) : location.state || {};
    });
    const [isEditMode, setIsEditMode] = useState(editDataState.isEditMode || false);

    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType } = useContext(UserContext);


    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [groupOptions, setGroupOptions] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [isSelectOpen, setIsSelectOpen] = useState(null);
    const [userName, setUserName] = useState("");
    const [displayName, setDisplayName] = useState("");

    const [loading, setLoading] = useState(false); // Add loading state

    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [status, setStatus] = useState(1);  // store only value

    const [scpOptions, setScpOptions] = useState([]);
    const [selectedScps, setSelectedScps] = useState([]);
    const [plantOptions, setPlantOptions] = useState([]);
    const [selectedPlants, setSelectedPlants] = useState([]);
    const [selectedLines, setSelectedLines] = useState([]);
    const [defaultScp, setDefaultScp] = useState(null);
    const [showAsterisks, setShowAsterisks] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({ user: '', password: '', msg: '' });
    const [imagePreview, setImagePreview] = useState(null);
    const [showImageModal, setShowImageModal] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [userNameError, setUserNameError] = useState('');
    const [displayNameError, setDisplayNameError] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState('');
    const prevCountryRef = useRef(phoneNumberCountry);


    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    module: "User Master",
                    action,
                    userCode: UM_UserCode,
                    isError,
                }),
            });

            if (!response.ok) {
                logAction("Failed to log action");
                throw new Error("Failed to log action");
            }
        } catch (error) {
            logAction("Error logging action:", true);
            console.error("Error logging action:", error);
        }
    };

    // useEffect(() => {
    //     if (location?.state !== null) {
    //         setEditDataState(location?.state);
    //         if (location.state.user) {
    //             const { user } = location.state;

    //             setUserName(user.UM_UserCode || "");
    //             setDisplayName(user.UM_DisplayName || "");
    //             setEmail(user.UM_EmailAddress || "");
    //             console.log(user)
    //             setSelectedGroup({value:user.UM_GroupId})
    //             setPhoneNumber(user.UM_PhoneNumber ? user.UM_PhoneNumber.replace(/[^\d]/g, '') : "91");
    //             phoneInitialized.current = false; // reset for new edit
    //             setStatus(user.UM_Status ?? 1);
    //             if (user.UM_CompanyID && user.CM_CompanyName) {
    //                 setSelectedCompany({ value: user.UM_CompanyID, label: user.CM_CompanyName });
    //             }

    //             if (user.UserTypeID && user.UserType) {
    //                 setSelectedOption({ value: user.UserTypeID, label: user.UserType });
    //             }

    //             if (user.UserTypeID === 3 && user.UM_DefaultSCPId && scpOptions.length > 0) {
    //                 const defaultScpOption = scpOptions.find(scp => scp.SCPM_ID === user.UM_DefaultSCPId);
    //                 console.log(user,scpOptions,user.UserTypeID === 3 && user.UM_DefaultSCPId && scpOptions.length > 0,defaultScpOption)

    //                 if (defaultScpOption) {
    //                     setDefaultScp({ value: defaultScpOption.SCPM_ID, label: defaultScpOption.SCPM_Name });
    //                 }
    //             }
    //         }
    //     }
    //     else {
    //         setDisplayName("")
    //         setEditDataState({});
    //     }

    // }, [isEditMode, editDataState, scpOptions, location.state]);

    useEffect(() => {
        if (isEditMode && editDataState.user) {
            console.log("editdatastate", editDataState.user)
            const { user } = editDataState;
            setUserName(user.UM_UserCode || "");
            setDisplayName(user.UM_DisplayName || "");
            setEmail(user.UM_EmailAddress || "");

            console.log("user detials", user.UM_PhoneNumber, user.UM_PhoneNumber.replace(/[^\d]/g, ''))
            setPhoneNumber(user.UM_PhoneNumber ? user.UM_PhoneNumber.replace(/[^\d]/g, '') : "91");
            phoneInitialized.current = false; // reset for new edit
            setStatus(user.UM_Status ?? 1);

            // Set selected company
            if (user.UM_CompanyID && user.CM_CompanyName) {
                setSelectedCompany({ value: user.UM_CompanyID, label: user.CM_CompanyName });
            }


            // Set user type
            if (user.UserTypeID && user.UserType) {
                setSelectedOption({ value: user.UserTypeID, label: user.UserType });
            }

            // Set default SCP if UserTypeID is 3 and UM_DefaultSCPId exists
            if (user.UserTypeID === 3 && user.UM_DefaultSCPId && scpOptions.length > 0) {
                const defaultScpOption = scpOptions.find(scp => scp.SCPM_ID === user.UM_DefaultSCPId);
                if (defaultScpOption) {
                    setDefaultScp({ value: defaultScpOption.SCPM_ID, label: defaultScpOption.SCPM_Name });
                }
            }
        }
    }, [isEditMode, editDataState, scpOptions]);

    useEffect(() => {
        const fetchPlantLineData = async () => {
            try {
                let response1, response2;

                if (isEditMode && editDataState.user?.UserTypeID === 2 && editDataState.user?.UM_UserId) {
                    const userId = editDataState.user?.UM_UserId;
                    const companyId =
                        parseInt(UM_UserType) === 0 ? selectedCompany?.value : UM_CompanyID;
                    if (!companyId) return;

                    // 1️⃣ Fetch existing mappings
                    response1 = await fetch(`${config.API_URL}/UM/resourcelistdata`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ userId }),
                    });

                    // 2️⃣ Fetch all plants & lines
                    response2 = await fetch(`${config.API_URL}/UM/resourcedata`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ companyId }),
                    });

                    if (!response1.ok || !response2.ok) throw new Error("Failed to fetch plant/line data");

                    const result1 = await response1.json();
                    const result2 = await response2.json();

                    // ✅ Apply plant options (for checkboxes UI)
                    setPlantOptions(result2);

                    // ✅ Apply pre-selected plants/lines
                    const { success, data, error } = result1;
                    if (!success) {
                        console.error("Error fetching user mappings:", error);

                        return;
                    }
                    setSelectedPlants(data.map((item) => item.plantid));
                    setSelectedLines(data.map((item) => item.lineid));
                }
                else if (!isEditMode && (selectedOption?.value === 2 || parseInt(UM_UserType) === 2)) {
                    // Create mode
                    const companyId =
                        parseInt(UM_UserType) === 0 ? selectedCompany?.value : UM_CompanyID;
                    if (!companyId) return;

                    response2 = await fetch(`${config.API_URL}/UM/resourcedata`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ companyId }),
                    });

                    if (!response2.ok) throw new Error("Failed to fetch plant/line data");

                    const result = await response2.json();
                    setPlantOptions(result);
                    setSelectedPlants([]);
                    setSelectedLines([]);
                }
                else {
                    return; // not applicable
                }
            } catch (error) {
                console.error("Error fetching plant/line data:", error);

            }
        };

        fetchPlantLineData();
    }, [
        isEditMode,
        editDataState.user?.UserTypeID,
        editDataState.user?.UM_UserId,
        selectedOption,
        selectedCompany,
        UM_UserType,
        UM_CompanyID,
    ]);

    useEffect(() => {

        // Skip if in edit mode or user type is not 3
        if (selectedOption?.value !== 3 && parseInt(UM_UserType) !== 3) {
            setGroupOptions([]);
            setSelectedGroup(null);
            return;
        }
        // If no Default SCP is selected, clear group options
        if (!defaultScp?.value) {
            setGroupOptions([]);
            setSelectedGroup(null);
            return;
        }
        const fetchScpGroups = async () => {
            try {
                const response = await fetch(`${config.API_URL}/UM/scpgroupmaster`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ scpId: defaultScp.value })
                });
                if (!response.ok) throw new Error('Failed to fetch SCP group options');
                const { success, data, error } = await response.json();
                if (!success) {
                    console.error('Error fetching SCP group data:', error);
                    setGroupOptions([]);
                    setSelectedGroup(null);
                    return;
                }
                const formattedGroups = data.map((item) => ({
                    value: item.GRPM_GroupId,
                    label: item.GRPM_GroupName
                }));
                setGroupOptions(formattedGroups);

                // If in edit mode, pre-select the group based on UM_GroupId
                if (isEditMode && location?.state?.user?.UM_GroupId) {
                    const preselected = formattedGroups.find(
                        (g) => g.value === parseInt(location?.state?.user?.UM_GroupId)
                    );

                    setSelectedGroup(preselected || null);
                } else {
                    setSelectedGroup(null);
                }
            } catch (error) {
                console.error('Error fetching SCP groups:', error);
                setGroupOptions([]);
                setSelectedGroup(null);
            }
        };
        fetchScpGroups();
    }, [defaultScp, selectedOption, isEditMode, UM_UserType, location?.state]);

    const fetchCompanyChannelValues = async (ccid) => {
        try {
            if (!ccid) return [];

            const response = await fetch(
                `${config.API_URL}/UM/companychannelvalue`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ C_CCID: ccid }),
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch channel values");
            }

            const result = await response.json();

            const values = result.map(item => item.C_ChannelValue);

            setChannelValues(values);   // state update
            return values;              // 🔥 return values
        } catch (error) {
            console.error("Error fetching channel values:", error);
            setChannelValues([]);
            return [];
        }
    };

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);
        sessionStorage.setItem("UM_UserType", UM_UserType);
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId, UM_UserType]);

    useEffect(() => {
        const fetchEnumOptions = async () => {
            try {
                const response = await fetch(`${config.API_URL}/CITPM/enumtype`);
                if (!response.ok) throw new Error('Failed to fetch enum options');
                const data = await response.json();

                let formattedOptions = data.map((item) => ({
                    value: item.EnumVal,
                    label: item.Description
                }));

                if (parseInt(UM_UserType) === 1) {
                    formattedOptions = formattedOptions.filter(opt => opt.value !== 1);
                } else if (parseInt(UM_UserType) === 2 || parseInt(UM_UserType) === 3) {
                    formattedOptions = [];
                }

                setOptions(formattedOptions);

                // Auto-select if there is only one option and not in edit mode
                if (!isEditMode && formattedOptions.length === 1) {
                    setSelectedOption(formattedOptions[0]);
                }

            } catch (error) {
                console.error('Error fetching enum options:', error);
            }
        };
        fetchEnumOptions();
    }, [UM_UserType, isEditMode]);

    useEffect(() => {
        const fetchCompanyOptions = async () => {
            try {
                const response = await fetch(`${config.API_URL}/CITPM/CMNAME`);
                if (!response.ok) throw new Error('Failed to fetch company options');
                const data = await response.json();
                console.log("company data", data)
                const formattedCompanyOptions = data.map((item) => ({
                    value: item.CM_ID,
                    label: item.CM_CompanyName,
                    CM_CompanyGrpId: item.CM_CompanyGrpId
                }));
                setCompanyOptions(formattedCompanyOptions);
            } catch (error) {
                console.error('Error fetching company options:', error);
            }
        };
        fetchCompanyOptions();
    }, []);

    const logAudit = async (
        module,
        message,
        CompanyID,
        CompanyGrpID,
        oldValue = "",
        newValue = "",
        isError = false,
        transactionDetails = []
    ) => {
        const auditLogPayload = {
            AUTR_ScreenName: module,
            AUTR_OldValue: oldValue,
            AUTR_NewValue: newValue,
            AUTR_CompanyGrpId: CompanyGrpID,
            AUTR_CompanyID: CompanyID,
            AUTR_Message: message,
            AUTR_UserID: UM_UserId,
            AUTR_UserName: UM_UserCode,
            AUTR_AuditType: 10,
            AUTR_SCPID: selectedScpId || 0,
            AUTR_CreatedBy: UM_UserId,
            insertAuditTransaction: transactionDetails.length > 0, // Flag to determine if transaction details should be inserted
            transactionDetails, // Array of transaction details to be inserted into audittransaction
        };

        try {
            const response = await fetch(`${config.API_URL}/audit/log`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(auditLogPayload),
            });

            if (!response.ok) {
                throw new Error("Failed to log action");
            }
        } catch (error) {
            console.error("Error logging action:", error);
        }
    };

    useEffect(() => {
        if (isEditMode && selectedGroup) return;
        if (parseInt(UM_UserType) === 3) return;

        // Decide companyId based on user type
        const companyId = parseInt(UM_UserType) === 0 ? selectedCompany?.value : UM_CompanyID;
        if (!companyId) return;

        const groupType = isEditMode
            ? editDataState.user?.UserTypeID
            : (parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1
                ? selectedOption?.value
                : parseInt(UM_UserType));

        // NEW: Skip if groupType === 3 (use SCP-specific groups instead)
        if (groupType === 3) return;

        const fetchGroups = async () => {
            try {
                const response = await fetch(
                    `${config.API_URL}/UM/groups?companyId=${companyId}&groupType=${groupType}`
                );
                if (!response.ok) throw new Error("Failed to fetch group options");
                const data = await response.json();

                const formattedGroups = data.map((item) => ({
                    value: item.GRPM_GroupId,
                    label: item.GRPM_GroupName,
                }));

                setGroupOptions(formattedGroups);

                // ✅ If editing, pre-select the group by UM_GroupId
                if (isEditMode && editDataState?.user?.UM_GroupId) {
                    const preselected = formattedGroups.find(
                        (g) => g.value === parseInt(editDataState.user?.UM_GroupId)
                    );
                    if (preselected) {
                        setSelectedGroup(preselected);
                    }
                } else if (formattedGroups.length === 1) {
                    // NEW: Auto-select if only one group in create mode
                    //setSelectedGroup(formattedGroups[0]);
                }
            } catch (error) {
                console.error("Error fetching groups:", error);
            }
        };

        fetchGroups();
    }, [isEditMode, selectedCompany, selectedOption, UM_UserType, UM_CompanyID]);

    useEffect(() => {
        const fetchScpData = async () => {
            try {
                const companyId = isEditMode
                    ? editDataState.user?.UM_CompanyID
                    : parseInt(UM_UserType) === 0
                        ? selectedCompany?.value
                        : UM_CompanyID;

                if (!companyId) {
                    console.warn("No companyId available, skipping SCP fetch");
                    return;
                }

                // 1️⃣ Fetch SCP options
                const response1 = await fetch(`${config.API_URL}/UM/scpdata`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ companyId, UM_UserType, UM_UserId }),
                });

                if (!response1.ok) throw new Error("Failed to fetch SCP Masters");
                const scpData = await response1.json();
                setScpOptions(scpData);


                // 2️⃣ If edit mode & UserTypeID = 3 → fetch user SCPs
                if (isEditMode && editDataState.user?.UserTypeID === 3 || editDataState.user?.UserTypeID === 4 && editDataState.user?.UM_UserId) {

                    const response2 = await fetch(
                        `${config.API_URL}/UM/userscpmasterlist/${editDataState.user?.UM_UserId}`
                    );

                    if (!response2.ok) throw new Error("Failed to fetch user SCP data");
                    const { success, data, error } = await response2.json();

                    if (!success) {
                        console.error("Error fetching SCP data:", error);

                        return;
                    }


                    // Directly use the data as SCP IDs (since it's an array of numbers)
                    const scpIds = data; // No need for mapping, as data is already [2, 1, 3]

                    setSelectedScps(scpIds);

                    // Set default SCP if UM_DefaultSCPId exists
                    if (editDataState.user?.UM_DefaultSCPId) {
                        const defaultScpOption = scpData.find(scp => scp.SCPM_ID === editDataState.user?.UM_DefaultSCPId);
                        if (defaultScpOption) {

                            setDefaultScp({ value: defaultScpOption.SCPM_ID, label: defaultScpOption.SCPM_Name });
                        } else {
                            console.warn("Default SCP not found in scpOptions:", editDataState.user?.UM_DefaultSCPId);
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching SCP Masters:", error);

            }
        };

        fetchScpData();
    }, [
        isEditMode,
        editDataState.user?.UserTypeID,
        editDataState.user?.UM_UserId,
        editDataState.user?.UM_CompanyID,
        editDataState.user?.UM_DefaultSCPId,
        selectedCompany?.value,
        UM_UserType,
        UM_CompanyID,
    ]);

    const handleSelectOpen = (selectName) => setIsSelectOpen(selectName);
    const handleSelectClose = () => setIsSelectOpen(null);

    const statusOptions = [
        { value: 1, label: "Active" },
        { value: 2, label: "Inactive" }
    ];

    const filteredLines = plantOptions
        .filter(plant => selectedPlants.includes(plant.plantId))
        .flatMap(plant =>
            plant.lines.map(line => ({
                ...line,
                plantId: plant.plantId,
                plantName: plant.plantName,
            }))
        );

    const handleSave = async () => {

        setLoading(true);
        const validationErrors = {};

        const getLocalPhoneDigits = (phone, dialCode) => {
            if (!phone) return "";

            let digits = phone.replace(/\D/g, "");
            console.log("digits before dial code removal:", digits);
            // Remove dial code ONCE if present
            if (dialCode && digits.startsWith(dialCode)) {
                digits = digits.slice(dialCode.length);
            }
            console.log("digits after dial code removal:", digits);
            return digits;
        };

        const selectedCCID =
            parseInt(UM_UserType) === 0 ? selectedCompany?.value : UM_CompanyID;

        console.log("selectedCCID:", selectedCCID);

        const values = await fetchCompanyChannelValues(selectedCCID);
        console.log("Channel Values:", values);
        const channels = values.map(String);

        console.log("phoneNumber.trim()", phoneNumber, phoneNumber.trim())
        if (parseInt(UM_UserType) === 0 && !selectedCompany) {
            validationErrors.CName = true;
        }
        console.log("UM_UserType", UM_UserType)
        if ((parseInt(UM_UserType) === 0 && selectedCompany) && !selectedOption) {
            validationErrors.UserType = true;
        }

        if (!selectedGroup) validationErrors.GName = true;
        if (!userName.trim()) validationErrors.UName = true;
        if (!displayName.trim()) validationErrors.DName = true;

        const alphaNumStartEnd = /^[A-Za-z0-9].*[A-Za-z0-9]$/;
        const hasConsecutiveSameSpecial = /([_@. ])\1/.test(userName);

        if (!alphaNumStartEnd.test(userName) && userName.length > 1 && userName !== '') {
            setUserNameError('First and Last character must be alphanumeric');
            setLoading(false);
            return;
        }
        else if (hasConsecutiveSameSpecial) {
            setUserNameError('Consecutive special characters are not allowed');
            setLoading(false);
            return;
        }
        else { setUserNameError(''); }

        if (!alphaNumStartEnd.test(displayName) && displayName.length > 1 && displayName !== '') {
            setDisplayNameError('First and Last character must be alphanumeric');
            setLoading(false);
            return;
        } else {
            setDisplayNameError('');
        }

        if (channels.includes('1')) {
            if (!email || !email.trim()) {
                validationErrors.Email = true;
            }
        }

        const localDigits = getLocalPhoneDigits(phoneNumber, phoneNumberCountry);


        if (channels.includes('2')) {
            if (!localDigits) {
                //validationErrors.PhoneNumber = true;
            }
        }

        if (!status) validationErrors.Status = true;
        console.log("selectedOption", selectedOption)
        console.log("selectedCompany", selectedCompany)
        if (selectedOption?.value === 3 && selectedCompany?.value) {
            if (selectedScps.length === 0) validationErrors.SCPList = true;
            if (!defaultScp) validationErrors.DSCP = true;
        } else if (selectedOption?.value === 3 && UM_CompanyID !== 0) {
            if (selectedScps.length === 0) validationErrors.SCPList = true;
            if (!defaultScp) validationErrors.DSCP = true;
        } else if (selectedOption?.value === 4 && selectedCompany?.value) {
            if (selectedScps.length === 0) validationErrors.SCPList = true;
        }
        if (selectedOption?.value === 2 && selectedCompany?.value) {
            if (selectedPlants.length === 0) validationErrors.PName = true;
            if (selectedLines.length === 0) validationErrors.LName = true;
        }

        setShowAsterisks(validationErrors);
        if (Object.keys(validationErrors).length > 0) {
            setLoading(false);
            return;
        }

        let formattedPhone = "";

        console.log("email", email)
        const emailPattern = /^[a-z0-9]+@[a-z]+\.(com|in|net|org|co\.in)$/;
        if (!/^[a-z0-9]+@[a-z]+\.(com|in|net|org|co\.in)$/.test(email) && email.trim() !== '') {
            setEmailError('Invalid email format');
            setLoading(false);
            return;
        }



        console.log("phoneNumber", phoneNumber)

        const isPhoneRequired = channels.includes('2'); // channel 2 = phone
        let digits = phoneNumber.replace(/\D/g, "");
        const dialCode = phoneNumberCountry;
        if (digits.startsWith(dialCode)) {
            digits = digits.slice(dialCode.length);
        }

        const hasUserTypedPhone = digits > 0;

        console.log("hasUserTypedPhone", hasUserTypedPhone, isPhoneRequired)
        if (isEditMode || hasUserTypedPhone || isPhoneRequired) {
            setPhoneNumberError("");

            let digits = phoneNumber.replace(/\D/g, "");
            const dialCode = phoneNumberCountry;

            // Remove dial code before validation
            if (digits.startsWith(dialCode)) {
                digits = digits.slice(dialCode.length);
            }

            if (digits) {

                const maxLength = phoneLengthMapping[dialCode] || 10;
                if (hasUserTypedPhone) {
                    if (digits.startsWith("0")) {
                        setPhoneNumberError("Phone number cannot start with 0");
                        setLoading(false);
                        return;
                    }
                    if (digits.length !== maxLength) {
                        setPhoneNumberError(`Phone number must be exactly ${maxLength} digits`);
                        setLoading(false);
                        return;
                    }
                    formattedPhone = `+${dialCode} ${digits}`;
                }
            }
        }
        else

            if (phoneNumber) {
                setPhoneNumberError("");

                const dialCode = phoneNumberCountry;
                // all digits typed (may include dialCode)
                let digits = phoneNumber.replace(/\D/g, "");
                console.log("digits before dial code removal:", digits);
                const maxLength = phoneLengthMapping[dialCode] || 10;

                // If user accidentally typed the dial code prefix, remove it once
                if (dialCode && digits.startsWith(dialCode)) {
                    // remove only the first occurrence
                    digits = digits.slice(dialCode.length);
                }

                if (digits) {
                    // Now digits = the local part (or whatever remains). Keep only up to maxLength.
                    let typedDigits = digits.slice(-maxLength);
                    const typedLength = typedDigits.length;
                    const localNumber = typedDigits; // explicit naming

                    console.log({
                        dialCode,
                        digits,        // after removing dialCode
                        typedDigits,   // trimmed to maxLength
                        localNumber,
                        typedLength,
                        localLength: localNumber.length
                    });


                    // Then: disallow local numbers starting with 0 (now meaningful because length == max)
                    if (localNumber.startsWith("0")) {
                        setPhoneNumberError(`Phone number cannot start with 0`);
                        setLoading(false);
                        return;
                    }

                    // First: require exact length (user must provide full local number)
                    if (typedLength !== maxLength) {
                        setPhoneNumberError(`Phone number must be exactly ${maxLength} digits`);
                        setLoading(false);
                        return;
                    }

                    formattedPhone = `+${dialCode} ${localNumber}`;
                }
            }


        const plantsWithLines = plantOptions
            .filter(plant => selectedPlants.includes(plant.plantId))
            .map(plant => ({
                plantId: plant.plantId,
                lines: plant.lines
                    .filter(line => selectedLines.includes(line.LM_LineID))
                    .map(line => line.LM_LineID)
            }));

        // Flatten new plant-line map
        const plantLineMap = plantsWithLines.flatMap(plant => {
            const plantName = plantOptions.find(p => p.plantId === plant.plantId)?.plantName || `Plant-${plant.plantId}`;

            return plant.lines.map(lineId => {
                const line = plantOptions
                    .find(p => p.plantId === plant.plantId)
                    ?.lines.find(l => l.LM_LineID === lineId);
                const lineName = line ? line.LM_LineName : `Line-${lineId}`;

                return {
                    "Plant Name": plantName,
                    "Line Name": lineName
                };
            });
        });

        // Flatten old plant-line map (for edit mode)
        const oldPlantLineMap = isEditMode && editDataState.user?.plantsWithLines
            ? editDataState.user?.plantsWithLines.flatMap(plant => {
                const plantName = plantOptions.find(p => p.plantId === plant.plantId)?.plantName || `Plant-${plant.plantId}`;

                return plant.lines.map(lineId => {
                    const line = plantOptions
                        .find(p => p.plantId === plant.plantId)
                        ?.lines.find(l => l.LM_LineID === lineId);
                    const lineName = line ? line.LM_LineName : `Line-${lineId}`;

                    return {
                        "Plant Name": plantName,
                        "Line Name": lineName
                    };
                });
            })
            : [];


        // Old SCP list (for edit mode)
        const oldSCPList = isEditMode && editDataState.user?.USM_SCPID?.length > 0
            ? editDataState.user?.USM_SCPID.map(id => {
                const scpName = scpOptions.find(scp => scp.SCPM_ID === id)?.SCPM_Name || `SCP-${id}`;
                return { "SCP Name": scpName };
            })
            : [];
        // Get SCP names as JSON array
        const scpNames = selectedScps.length > 0
            ? scpOptions
                .filter(scp => selectedScps.includes(scp.SCPM_ID))
                .map(scp => scp.SCPM_Name)
            : [];

        // New SCP list (current selection)
        const newSCPList = scpNames.length > 0
            ? scpNames.map(name => ({ "SCP Name": name }))
            : [];

        let finalUserType;
        if (parseInt(UM_UserType) === 2 || parseInt(UM_UserType) === 3) {
            finalUserType = UM_UserType;   // take from state/context
        } else {
            finalUserType = selectedOption?.value;  // take from dropdown
        }

        const finalStatusmain =
            status && typeof status === "object"
                ? status.value
                : Number(status);


        console.log("statusstatus", status)
        // const finalstatus = isEditMode ? status?.value : finalStatusmain;

        if (emailError) {
            console.log("setemailerror", emailError)
            setLoading(false);
            return;
        }

        const payload = {
            UM_UserCode: userName,
            UM_DisplayName: displayName,
            UM_EmailAddress: email,
            UM_PhoneNumber: formattedPhone,
            UM_Status: finalStatusmain,
            UM_PasswordAttemptsCount: 0,
            UM_GroupId: selectedGroup?.value,
            UM_CompanyGrpID: parseInt(UM_UserType) === 0 ? selectedCompany?.CM_CompanyGrpId : UM_CompanyGrpID,
            UM_CompanyID: parseInt(UM_UserType) === 0 ? selectedCompany?.value : UM_CompanyID,
            UM_DefaultSCPId: defaultScp?.value || null,
            UM_CreatedBy: UM_UserId,
            UM_UserType: finalUserType,
            plantsWithLines,
            USM_SCPID: selectedScps,
        };

        console.log("payload", payload)

        if (isEditMode) {
            payload.UM_UserId = editDataState.user?.UM_UserId || UM_UserId;
            payload.UM_UpdatedBy = UM_UserId;
            payload.OldStatus = editDataState.user?.UM_Status || finalStatusmain;
        }

        const transactionDetails = [
            {
                AUTRN_OldValue: isEditMode ? editDataState.user?.UM_UserCode : "-",
                AUTRN_NewValue: userName,
                AUTRN_ParamererName: "User Name",
            },
            {
                AUTRN_OldValue: isEditMode ? editDataState.user?.UM_DisplayName : "-",
                AUTRN_NewValue: displayName,
                AUTRN_ParamererName: "Display Name",
            },
            ...(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1
                ? [
                    {
                        AUTRN_OldValue: isEditMode ? editDataState.user?.UserType : "-",
                        AUTRN_NewValue: selectedOption?.label,
                        AUTRN_ParamererName: "User Type",
                    },
                ]
                : []),
            {
                AUTRN_OldValue: isEditMode ? editDataState.user?.GRPM_GroupName : "-",
                AUTRN_NewValue: selectedGroup?.label,
                AUTRN_ParamererName: "Group Name",
            },
            {
                AUTRN_OldValue:
                    isEditMode && editDataState.user?.UM_EmailAddress
                        ? editDataState.user?.UM_EmailAddress
                        : "-",
                AUTRN_NewValue: email?.trim() ? email : "-",
                AUTRN_ParamererName: "Email",
            },
            {
                AUTRN_OldValue:
                    isEditMode && editDataState.user?.UM_PhoneNumber
                        ? editDataState.user?.UM_PhoneNumber
                        : "-",
                AUTRN_NewValue: formattedPhone?.trim() ? formattedPhone : "-",
                AUTRN_ParamererName: "Phone Number",
            },
            {
                AUTRN_OldValue: isEditMode
                    ? (editDataState.user?.UM_Status === 1 ? "Active" : "Inactive")
                    : "-",
                AUTRN_NewValue: parseInt(finalStatusmain) === 1 ? "Active" : "Inactive",
                AUTRN_ParamererName: "Status",
            },
            {
                AUTRN_OldValue: oldSCPList.length > 0 ? JSON.stringify(oldSCPList) : "-",
                AUTRN_NewValue: newSCPList.length > 0 ? JSON.stringify(newSCPList) : "-",
                AUTRN_ParamererName: "SCP Name List",
            },
            {
                AUTRN_OldValue: isEditMode
                    ? scpOptions.find(
                        scp => scp.SCPM_ID === editDataState.user?.UM_DefaultSCPId
                    )?.SCPM_Name || "-"
                    : "-",
                AUTRN_NewValue: defaultScp?.label || "-",
                AUTRN_ParamererName: "Default SCP",
            },
            {
                AUTRN_OldValue: oldPlantLineMap.length > 0 ? JSON.stringify(oldPlantLineMap) : "-",
                AUTRN_NewValue: plantLineMap.length > 0 ? JSON.stringify(plantLineMap) : "-",
                AUTRN_ParamererName: "Plant-Line Details",
            },

        ];

        try {
            setLoading(true);
            logAction(`handleSave() : Executing API : ${config.API_URL}/UM/usermaster} | DATA :  ${JSON.stringify(payload)}`);
            const response = await fetch(`${config.API_URL}/UM/usermaster`, {
                method: isEditMode ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
            if (!response.ok) {
                logAction(
                    `handleSave() : Error in Executing API : [${response.status} ${response.statusText}] - ${data.message || "Failed to save user"}}`
                );
                throw new Error(data.message || "Failed to save user");
            }



            const actionText = isEditMode ? "updated" : "saved";

            const companyID =
                parseInt(UM_UserType) === 0
                    ? selectedCompany?.value
                    : UM_CompanyID;

            const CompanyGroupID =
                parseInt(UM_UserType) === 0
                    ? selectedCompany?.CM_CompanyGrpId
                    : UM_CompanyGrpID;

            logAction(`handleSave() : User : ${userName} ${actionText} successfully`);
            logAudit(
                "User Master",
                `User : ${userName} ${actionText} successfully`, companyID, CompanyGroupID,
                "-",
                `${userName}`,
                false,
                transactionDetails
            );
            if (parseInt(finalStatusmain) === 2) {
                toast.success(`User : ${userName} ${actionText} successfully.`, {
                    onClose: () => {
                        resetUserForm();
                        setLoading(false);
                        setStatus(1)
                    }
                });

            } else if (parseInt(finalStatusmain) === 1) {
                if (!isEditMode && data.password) {
                    setModalData({ user: userName, password: data.password, msg: `${actionText}` });
                    setShowModal(true);
                } else if (isEditMode && editDataState.user?.UM_Status === 2) {
                    setModalData({ user: userName, password: data.password, msg: `${actionText}` });
                    setShowModal(true);
                }

                toast.success(`User : ${userName} ${actionText} successfully.`, {
                    onClose: () => {
                        resetUserForm();
                        setLoading(false);
                    }
                });

            }



        } catch (error) {
            console.error('Error saving user:', error);
            logAction(`handleSave() : Error in Executing API : ${config.API_URL}/UM/usermaster | Error : ${error}`, true);
            toast.error(error.message || 'Error saving user', {
                onClose: () => setLoading(false)
            });
        }
    };

    useEffect(() => {
        if (selectedOption?.value === 2 || selectedOption?.value === 1) {
            setSelectedScps([]);
            setDefaultScp(null);
            if (isEditMode && editDataState.user?.UserTypeID !== 3) {
                setSelectedScps([]);
                setDefaultScp(null);
            }
        }
        if (selectedOption?.value === 3 || selectedOption?.value === 1) {
            setSelectedPlants([]);
            setSelectedLines([]);
            if (isEditMode && editDataState.user?.UserTypeID !== 2) {
                setSelectedPlants([]);
                setSelectedLines([]);
            }
        }
    }, [selectedOption, isEditMode, editDataState]);

    const handleSelectAllPlants = (checked) => {
        if (checked) {
            setSelectedPlants(plantOptions.map(p => p.plantId));
        } else {
            setSelectedPlants([]);
        }
    };

    const handleSelectAllLines = (checked) => {
        if (checked) {
            setSelectedLines(filteredLines.map(l => l.LM_LineID));
        } else {
            setSelectedLines([]);
        }
    };

    const handleReset = () => {
        // move page to top
        const container = document.querySelector(".main_container");
        if (container) {
            container.scrollTop = 0;
        }
        if (isEditMode && editDataState?.user) {
            const { user } = editDataState;
            const isScpUser = user.UserTypeID === 3; // Check if user type is SCP (UserTypeID === 3)

            // Reset basic fields to their original fetched values
            setUserName(user.UM_UserCode || "");
            setDisplayName("");
            setEmail("");
            setPhoneNumber("");
            setPhoneNumberCountry('91');
            setResetCounter(prev => prev + 1);
            setPhoneNumberCountry(user.UM_PhoneNumber ? user.UM_PhoneNumber.match(/^\+(\d+)/)?.[1] || "91" : "91");
            setStatus(1);
            setSelectedCompany(user.UM_CompanyID && user.CM_CompanyName ? { value: user.UM_CompanyID, label: user.CM_CompanyName } : null);
            setSelectedOption(user.UserTypeID && user.UserType ? { value: user.UserTypeID, label: user.UserType } : null);

            // Reset SCP and plant/line selections
            if (isScpUser) {
                setSelectedScps([]); // Clear SCP Name List for SCP users
                setSelectedGroup(null); // Clear Group Name for SCP users
                // setGroupOptions([]); // Clear group options for SCP users
                setDefaultScp(null); // Clear Default SCP for SCP users
            } else {
                setSelectedScps(Array.isArray(user.USM_SCPID) ? user.USM_SCPID : []); // Reset SCP Name List for non-SCP users
                setSelectedPlants(user.plantsWithLines?.map(p => p.plantId) || []); // Reset selected plants
                setSelectedLines(user.plantsWithLines?.flatMap(p => p.lines) || []); // Reset selected lines
                setDefaultScp(
                    user.UM_DefaultSCPId && scpOptions.find(scp => scp.SCPM_ID === user.UM_DefaultSCPId)
                        ? { value: user.UM_DefaultSCPId, label: scpOptions.find(scp => scp.SCPM_ID === user.UM_DefaultSCPId).SCPM_Name }
                        : null
                ); // Reset Default SCP for non-SCP users

                // Handle group name reset for non-SCP users
                const preselectedGroup = user.UM_GroupId && user.GRPM_GroupName
                    ? { value: user.UM_GroupId, label: user.GRPM_GroupName }
                    : null;
                const companyId = user.UM_CompanyID;
                const groupType = user.UserTypeID;

                const fetchGroups = async () => {
                    try {
                        const response = await fetch(
                            `${config.API_URL}/UM/groups?companyId=${companyId}&groupType=${groupType}`
                        );
                        if (!response.ok) throw new Error("Failed to fetch group options");
                        const data = await response.json();
                        const formattedGroups = data.map((item) => ({
                            value: item.GRPM_GroupId,
                            label: item.GRPM_GroupName,
                        }));
                        setGroupOptions(formattedGroups);

                        // Set the pre-selected group if it exists in the fetched options
                        // Do NOT auto-select any group on reset
                        setSelectedGroup(null);

                    } catch (error) {
                        console.error("Error fetching groups:", error);
                        setGroupOptions([]);
                        setSelectedGroup(preselectedGroup); // Fallback to preselected group
                    }
                };


                if (companyId && groupType && groupType !== 3) {
                    fetchGroups();
                } else {
                    setGroupOptions([]); // Clear options if companyId, groupType missing, or SCP user
                    setSelectedGroup(preselectedGroup); // Fallback to preselected group
                }
            }

            // Clear validation errors and asterisks
            setShowAsterisks({});
            setEmailError('');
            setDisplayNameError('');
            setUserNameError('');
            setPhoneNumberError('');
        } else {
            const isOnlyOptionSCP =
                parseInt(UM_UserType) === 1 &&       // Current user type is 1
                options.length === 1 &&              // Only one option available
                options[0]?.value === 3;             // The only option is SCP (value=3)
            console.log("isOnlyOptionSCP", isOnlyOptionSCP)

            setUserName("");
            setDisplayName("");
            setEmail("");
            setPhoneNumber("");
            setPhoneNumberCountry('91');
            setResetCounter(prev => prev + 1);


            setSelectedCompany(null);
            setSelectedGroup(null);
            setStatus(1);
            setGroupOptions([]);
            setShowAsterisks({});
            setEmailError('');
            setDisplayNameError('');
            setUserNameError('');
            setPhoneNumberError('');

            if (isOnlyOptionSCP) {
                // 🚫 Do NOT clear full form, only uncheck SCP checkboxes
                setSelectedScps([]);  // only clear SCP selection                 
                return;  // 🛑 Stop here, don't reset everything!
            }

            setSelectedOption(null);
            setSelectedScps([]);
            setSelectedPlants([]);
            setSelectedLines([]);
            setDefaultScp(null);
        }
    };

    const renderLabel = (field, label) => {
        return (
            <label className="label1">
                {label}
                {showAsterisks[field] && <span className="text-danger">*</span>}
            </label>
        );
    };

    // Unified handleChange function
    const handleChange = (id, value, countryData) => {

        switch (id) {
            case 'CName':
                // ReactSelectDropDown sends just value, so we find the full object
                const selected = companyOptions.find(c => c.value === value);
                setSelectedCompany(selected || null);

                // Reset UserType, Group fields
                setSelectedOption(null);
                setSelectedGroup(null);
                setGroupOptions([]);

                if (value) clearAsterisk('CName');
                break;


            case 'UName':
                // Sanitize input
                value = value.replace(/[^a-zA-Z0-9_@. ]/g, '');
                value = value.slice(0, 45); // limit to 45 chars

                // Check if first and last characters are alphanumeric
                const firstCharValid = value.length === 0 || /^[a-zA-Z0-9]/.test(value[0]);
                const lastCharValid = value.length === 0 || /[a-zA-Z0-9]$/.test(value[value.length - 1]);
                const hasConsecutiveSameSpecial = /([_@. ])\1/.test(value);

                if (!firstCharValid || !lastCharValid) {
                    setUserNameError('First and Last character must be alphanumeric');
                } else if (hasConsecutiveSameSpecial) {
                    setUserNameError('Consecutive special characters are not allowed');
                } else {
                    setUserNameError('');
                }

                setUserName(value);
                if (value.trim()) clearAsterisk('UName');
                break;


            case 'UserType':
                // Find full option object from value
                console.log("selectedGroup before UserType change:", selectedGroup);
                const selectedtype = options.find(o => o.value === value) || null;

                setSelectedOption(selectedtype);
                setSelectedGroup("");
                setGroupOptions([]);

                if (value) clearAsterisk('UserType');
                console.log("selectedGroup after UserType change:", selectedGroup);
                break;

            case 'GName':
                const selectedgroup = groupOptions.find(g => g.value === value) || null;
                setSelectedGroup(selectedgroup);

                if (value) clearAsterisk('GName');
                break;
            case 'DName':
                // Allow only letters, numbers, and spaces
                value = value.replace(/[^a-zA-Z0-9 ]/g, '');

                // Collapse multiple spaces into one
                value = value.replace(/\s+/g, ' ');
                value = value.slice(0, 45);
                // Remove leading space immediately (don't allow)
                if (value.startsWith(' ')) {
                    value = value.trimStart();
                }

                // Check for trailing space
                if (value.endsWith(' ')) {
                    setDisplayNameError('First and Last character must be alphanumeric');
                } else {
                    setDisplayNameError('');
                }

                setDisplayName(value);

                if (value.trim()) clearAsterisk('DName');
                break;



            case 'Email':
                let trimmedValue = value.trim();
                // ❌ If only spaces, don't set anything
                if (trimmedValue === "") {
                    setEmail("");
                    setEmailError("");
                    return;
                }

                // Apply max length + lowercase
                trimmedValue = trimmedValue.slice(0, 45).toLowerCase();

                setEmail(trimmedValue);

                clearAsterisk('Email');

                // Validate email format
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!emailPattern.test(trimmedValue) && trimmedValue.trim() !== '') {
                    setEmailError('Invalid email format');
                } else {
                    setEmailError(''); // clear error if valid
                }
                break;


            // case "PhoneNumber": {
            //     console.log("---- PHONE NUMBER HANDLER START ----");

            //     const prevPhone = phoneNumber;
            //     const dialCode = countryData?.dialCode || phoneNumberCountry;
            //     const isDeleting = value.length < prevPhone.length;
            //     const maxLength = phoneLengthMapping[dialCode] || 10;

            //     console.log({ prevPhone, dialCode, value, isDeleting });

            //     // Sanitize input
            //     let digits = value.replace(/\D/g, "");
            //     console.log("Sanitized:", digits);

            //     // Remove dial code if user typed it
            //     if (digits.startsWith(dialCode)) {
            //         digits = digits.slice(dialCode.length);
            //         console.log("After removing dialCode:", digits);
            //     }

            //     // Trim only local part
            //     let local = digits.slice(0, maxLength);
            //     console.log("Local:", local);

            //     // ❗ SHOW ERROR but DO NOT BLOCK
            //     if (local.startsWith("0") && local.length > 0) {
            //         console.log("Local starts with 0 → show error only");
            //         setPhoneNumberError("Phone number cannot start with 0");
            //     } else {
            //         setPhoneNumberError("");
            //     }

            //     // Build final phone = dialCode + local
            //     const finalValue = dialCode + local;
            //     console.log("Setting phoneNumber:", finalValue);

            //     setPhoneNumber(finalValue);

            //     if (finalValue) {
            //         clearAsterisk("PhoneNumber");
            //     }

            //     console.log("---- PHONE NUMBER HANDLER END ----");
            //     break;
            // }

            case "PhoneNumber": {
                console.log("---- PHONE NUMBER HANDLER START ----");

                const prevPhone = phoneNumber;
                const newDialCode = countryData?.dialCode;
                const prevDialCode = prevCountryRef.current;
                const isCountryChange = newDialCode !== prevDialCode;

                const maxLength = phoneLengthMapping[newDialCode] || 10;

                let digits = value.replace(/\D/g, "");

                // 🔑 ONLY strip dial code when USER TYPES, not when country changes
                if (!isCountryChange && digits.startsWith(newDialCode)) {
                    digits = digits.slice(newDialCode.length);
                }

                let local = digits.slice(0, maxLength);

                // Error only (do not block)
                if (local.startsWith("0") && local.length > 0) {
                    setPhoneNumberError("Phone number cannot start with 0");
                } else {
                    setPhoneNumberError("");
                }

                // ✅ On country change → reset local number
                const finalValue = isCountryChange
                    ? newDialCode
                    : newDialCode + local;

                setPhoneNumber(finalValue);

                if (finalValue) {
                    clearAsterisk("PhoneNumber");
                }

                // update ref
                prevCountryRef.current = newDialCode;

                console.log("---- PHONE NUMBER HANDLER END ----");
                break;
            }

            case 'Status':
                setStatus(value);                      // store only numeric
                if (value) clearAsterisk('Status');
                break;

            case 'SCPList': {
                const effectiveUserType = selectedOption?.value || parseInt(UM_UserType);
                setSelectedScps((prev) => {
                    let updated;
                    if (prev.includes(value)) {
                        updated = prev.filter((id) => id !== value);
                    } else {
                        updated = [...prev, value];
                    }
                    // Only set defaultScp if effectiveUserType === 3
                    if (effectiveUserType === 3) {
                        if (!prev.includes(value)) {
                            const lastCheckedSCP = scpOptions.find(scp => scp.SCPM_ID === value);
                            if (lastCheckedSCP) {
                                setDefaultScp({ value: lastCheckedSCP.SCPM_ID, label: lastCheckedSCP.SCPM_Name });
                                clearAsterisk('DSCP');
                            }
                        } else if (updated.length > 0) {
                            const lastCheckedId = updated[updated.length - 1];
                            const lastCheckedSCP = scpOptions.find(scp => scp.SCPM_ID === lastCheckedId);
                            if (lastCheckedSCP) {
                                setDefaultScp({ value: lastCheckedSCP.SCPM_ID, label: lastCheckedSCP.SCPM_Name });
                                clearAsterisk('DSCP');
                            }
                        } else {
                            setDefaultScp(null);
                        }
                    } else if (effectiveUserType === 4) {
                        // Ensure defaultScp is null for Sales users
                        setDefaultScp(null);
                        clearAsterisk('DSCP');
                    }
                    if (updated.length > 0) clearAsterisk('SCPList');
                    return updated;
                });
                break;
            }
            case 'PName':
                setSelectedPlants((prev) =>
                    prev.includes(value)
                        ? prev.filter((id) => id !== value)
                        : [...prev, value]
                );
                if (selectedPlants.length > 0 || !selectedPlants.includes(value)) {
                    clearAsterisk('PName');
                }
                break;
            case 'LName':
                setSelectedLines((prev) =>
                    prev.includes(value)
                        ? prev.filter((id) => id !== value)
                        : [...prev, value]
                );
                if (selectedLines.length > 0 || !selectedLines.includes(value)) {
                    clearAsterisk('LName');
                }
                break;
            case 'DSCP':
                const selectedDSCP = scpOptions
                    .filter((scp) => selectedScps.includes(scp.SCPM_ID))
                    .map((scp) => ({ value: scp.SCPM_ID, label: scp.SCPM_Name }))
                    .find(opt => opt.value === value) || null;

                setDefaultScp(selectedDSCP);

                if (value) clearAsterisk('DSCP');
                break;
            default:
                break;
        }
    };

    // Helper function to clear asterisk for a specific field
    const clearAsterisk = (field) => {
        setShowAsterisks((prev) => {
            const updated = { ...prev };
            delete updated[field];
            return updated;
        });
    };

    const resetUserForm = () => {

        // ✅ Clear edit mode
        setEditDataState({});
        setIsEditMode(false);
        localStorage.removeItem("user"); // optional, to avoid reload issues
        setUserName("");
        setDisplayName("");
        setEmail("");
        setPhoneNumber("");
        setPhoneNumberCountry('91');
        setResetCounter(prev => prev + 1);

        // Reset company always
        setSelectedCompany(null);
        setSelectedGroup(null);
        setStatus({ value: 1, label: "Active" });
        setGroupOptions([]);
        setShowAsterisks({});

        // Reset selections
        setSelectedScps([]);
        setSelectedPlants([]);
        setSelectedLines([]);
        setDefaultScp(null);

        // ✅ Reset dropdowns only for Super Admin
        if (parseInt(UM_UserType) === 0 || (parseInt(UM_UserType) === 1 && options.length > 1)) {
            setSelectedOption(null);
        }
    };

    const useDropdownScrollEffect = (isOpen, enable = true) => {


        //if (!enable) return;

        const mainContainer = document.querySelector('.main_container');

        //console.log("isOpen changed:", isOpen);
        if (isOpen) {
            // setTimeout(() => {
            //     const dropdown =
            //         document.querySelector('.react-select__menu') ||
            //         document.querySelector('.phone-dropdown-scroll');

            //     const dropdownHeight = dropdown?.offsetHeight || 100;
            //     const gap = 30;

            //     if (mainContainer) {
            //         mainContainer.style.paddingBottom = `${dropdownHeight + gap}px`;
            //         mainContainer.scrollTo({
            //             top: mainContainer.scrollHeight,
            //             behavior: 'smooth',
            //         });
            //     }
            // }, 100);
        } else {
            if (mainContainer) {
                mainContainer.style.paddingBottom = '';
            }
        }
    };

    const handleStatusSelectChange = (selectedOption) => {
        logAction('handleStatusSelectChange():Started')
        setStatus(selectedOption?.value || 1)

        logAction(`handleStatusSelectChange():Selected Status - ${selectedOption?.label || 'Active'}`);
    };

    return (
        <>
            {loading && (
                <div style={{
                    position: 'fixed', // Sit on top of the page content
                    left: 0,
                    top: 0,
                    width: '100%', // Full width
                    height: '100%', // Full height

                    zIndex: 1000 // Sit on top of the other elements
                }} />
            )}
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />

            <div className="main_container">

                <h3 className="formHeading">User Master</h3>
                <div className='your-form-container'>
                    <div className='row'>
                        {/* Company Name Select */}
                        {parseInt(UM_UserType) === 0 && (
                            <div className="col-md-4">

                                <div className="mb-3">
                                    {renderLabel("CName", "Company Name")}
                                    <div
                                        className="select-container_list"

                                    >
                                        <ReactSelectDropDown
                                            name="CName"
                                            options={companyOptions}
                                            value={selectedCompany?.value || ""}
                                            onChange={(e) => handleChange("CName", e.target.value)}
                                            placeholder="--Select--"
                                            idKey="value"
                                            displayKey="label"
                                            disabled={isEditMode}
                                            onMenuOpen={() => !isEditMode && handleSelectOpen("Company")}
                                            onMenuClose={handleSelectClose}
                                            className={isEditMode ? "force-no-opacity" : ""}
                                            style={{
                                                backgroundColor: isEditMode ? '#f2f2f2' : '',
                                                color: isEditMode ? '#6c757d' : '',
                                                cursor: isEditMode ? 'not-allowed' : '',
                                                opacity: isEditMode ? '1 !important' : '1',   // <-- override disabled opacity
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* User Name Input */}
                        <div className="col-md-4">
                            <div className="mb-3">
                                {renderLabel("UName", "User Name")}
                                <input
                                    type="text"
                                    className='form-input'
                                    value={userName}
                                    onChange={(e) => handleChange('UName', e.target.value)}
                                    disabled={isEditMode}
                                    style={isEditMode ? { backgroundColor: '#f2f2f2', color: '#465a64  ' } : {}}
                                    autoComplete="off"
                                />
                                {userNameError && (
                                    <p className="text-danger mt-1">{userNameError}</p> // inline error
                                )}
                            </div>
                        </div>

                        {/* User Type Select */}
                        {parseInt(UM_UserType) !== 2 && parseInt(UM_UserType) !== 3 && options.length > 1 && (
                            <div className="col-md-4">
                                <div className="mb-3">
                                    {renderLabel("UserType", "User Type")}
                                    <div className="select-container_list">
                                        <ReactSelectDropDown
                                            id="enum-select"
                                            name="UserType"
                                            options={options}
                                            value={selectedOption?.value || ""}
                                            onChange={(e) => handleChange("UserType", e.target.value)}
                                            placeholder="--Select--"
                                            idKey="value"
                                            displayKey="label"
                                            disabled={isEditMode || (selectedCompany === null)}
                                            onMenuOpen={() => handleSelectOpen("PType")}
                                            onMenuClose={handleSelectClose}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* SCP Name List — ONLY shows if condition true, otherwise NOTHING */}
                        {(
                            // Admin selecting SCP-user type
                            (UM_UserType == 1 && [3, 4].includes(selectedOption?.value)) ||

                            // SuperAdmin selecting SCP-user type
                            (UM_UserType == 0 && selectedCompany?.value && [3, 4].includes(selectedOption?.value)) ||

                            // UM_UserType === 3 must always show SCP list (because user is SCP user)
                            (UM_UserType == 3)
                        )
                            && (
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        {renderLabel("SCPList", "SCP Name List")}
                                        <div className="form-check">
                                            {scpOptions.map((scp) => (
                                                <div key={scp.SCPM_ID}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`scp-${scp.SCPM_ID}`}
                                                        value={scp.SCPM_ID}
                                                        checked={selectedScps.includes(scp.SCPM_ID)}
                                                        onChange={() => handleChange("SCPList", scp.SCPM_ID)}
                                                    />
                                                    <label htmlFor={`scp-${scp.SCPM_ID}`} className="form-check-label">
                                                        {scp.SCPM_Name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}

                        {/* Group Name Select */}
                        <div className="col-md-4">
                            <div className="mb-3">
                                {renderLabel("GName", "Group Name")}
                                <div className="select-container_list">
                                    <ReactSelectDropDown
                                        name="GName"
                                        options={groupOptions}
                                        value={selectedGroup?.value || ""}   // ReactSelectDropDown must receive only value
                                        onChange={(e) => handleChange("GName", e.target.value)}
                                        placeholder="--Select--"
                                        idKey="value"
                                        displayKey="label"
                                        disabled={
                                            (
                                                ((parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) &&
                                                    parseInt(selectedOption?.value) === 3 &&
                                                    selectedScps.length === 0)
                                                ||
                                                (parseInt(UM_UserType) === 3 && selectedScps.length === 0)
                                            )
                                        }
                                        onMenuOpen={() => handleSelectOpen("GName")}
                                        onMenuClose={handleSelectClose}
                                    />


                                </div>
                            </div>
                        </div>

                        {/* Display Name Input */}
                        <div className="col-md-4">
                            <div className="mb-3">
                                {renderLabel("DName", "Display Name")}
                                <input
                                    type="text"
                                    className="form-input"
                                    value={displayName}
                                    autoComplete="off"
                                    onChange={(e) => handleChange("DName", e.target.value)}
                                />
                                {displayNameError && (
                                    <p className="text-danger mt-1">{displayNameError}</p> // inline error
                                )}
                            </div>
                        </div>
                        {(parseInt(UM_UserType) === 1 && options.length > 1) && (
                            <div className="col-md-4">
                                <div className="mb-3">
                                    {/* {renderLabel("Status", "Status")}
                                <div className="select-container_list">
                                    <ReactSelectDropDown
                                        name="Status"
                                        options={statusOptions}                   // [{ value:1, label:"Active" }...]
                                        value={status}                            // MUST pass only number
                                        onChange={(e) => handleChange("Status", e.target.value)}
                                        placeholder="--Select--"
                                        idKey="value"
                                        displayKey="label"
                                        disabled={false}
                                        onMenuOpen={() => handleSelectOpen("Status")}
                                        onMenuClose={handleSelectClose}
                                    />
                                </div> */}

                                    <label className='form-label'>Status </label>
                                    <div className='select-container'>
                                        <Select
                                            name='Status'
                                            placeholder='--Select--'
                                            options={statusOptions}
                                            value={statusOptions.find(option => option.value === status)}
                                            onChange={handleStatusSelectChange}
                                            isClearable={false}
                                            isSearchable={false}
                                            className="routing_select-box"
                                            classNamePrefix="react-select"
                                            components={{ SingleValue: CustomSingleValue }}
                                            onMenuOpen={() => handleSelectOpen("Status")}
                                            onMenuClose={handleSelectClose}
                                            enableScrollEffect={UM_UserId === 0 ? false : true}
                                        />
                                        <div className="icon-container_list myList">
                                            {isSelectOpen === "Status" ? (
                                                <IoCaretUpOutline />
                                            ) : (
                                                <IoCaretDownOutline />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="col-md-4">
                            <div className="mb-3">
                                {renderLabel("Email", "Email")}
                                <input
                                    type="text"
                                    className='form-input'
                                    value={email}
                                    autoComplete="new-email"
                                    onChange={(e) => handleChange('Email', e.target.value)}
                                />
                                {emailError && (
                                    <p className="text-danger mt-1">{emailError}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="mb-3">
                                {renderLabel("PhoneNumber", "Phone Number")}
                                {/* <PhoneInput
                                        key={phoneNumberCountry + '-' + resetCounter}
                                        country={phoneNumberToCountryCode(phoneNumberCountry) || 'in'}
                                        value={phoneNumber}
                                        onChange={(value, countryData) => handleChange('PhoneNumber', value, countryData)}
                                        inputClass="form-input"
                                        countryCodeEditable={false}
                                        onlyCountries={allowedCountries}
                                        autoComplete="off"
                                    /> */}

                                <PhoneInput
                                    className="phone-input-custom"
                                    key={phoneNumberCountry + '-' + resetCounter}
                                    country={phoneNumberToCountryCode(phoneNumberCountry) || 'in'}
                                    value={phoneNumber}
                                    onChange={(value, countryData) =>
                                        handleChange('PhoneNumber', value, countryData)
                                    }
                                    inputClass="form-input"
                                    dropdownClass="phone-dropdown-scroll phone-dropdown-up"
                                    countryCodeEditable={false}
                                    onlyCountries={allowedCountries}
                                    autoComplete="off"
                                />
                                {phoneNumberError && (
                                    <p className="text-danger mt-1">{phoneNumberError}</p>
                                )}
                            </div>
                        </div>

                        <div className="col-md-4">
                            {/* Phone Number Input */}
                            {((parseInt(UM_UserType) === 1 && options.length === 1) || parseInt(UM_UserType) === 2 || parseInt(UM_UserType) === 3
                                || parseInt(UM_UserType) === 0) && (
                                    <div className="mb-3">
                                        {/* {renderLabel("Status", "Status")}

                                    <div className="select-container_list">
                                        <StatusCustomDropdown
                                            name="Status"
                                            options={statusOptions}
                                            value={status}                        // ⬅ MUST pass only value
                                            onChange={(e) => handleChange("Status", e.target.value)}
                                            idKey="value"
                                            displayKey="label"
                                            onMenuOpen={() => handleSelectOpen("Status")} // (optional needs in component)
                                            onMenuClose={handleSelectClose}               // (optional needs in component)
                                            enableScrollEffect={UM_UserId === 0 ? false : true}    // only enable for non-superadmin
                                        />
                                    </div> */}
                                        <label className='form-label'>Status </label>
                                        <div className='select-container'>
                                            <Select
                                                name='Status'
                                                placeholder='--Select--'
                                                options={statusOptions}
                                                value={statusOptions.find(option => option.value === status)}
                                                onChange={handleStatusSelectChange}
                                                isClearable={false}
                                                isSearchable={false}
                                                className="routing_select-box"
                                                classNamePrefix="react-select"
                                                components={{ SingleValue: CustomSingleValue }}
                                                onMenuOpen={() => handleSelectOpen("Status")}
                                                onMenuClose={handleSelectClose}
                                                enableScrollEffect={UM_UserId === 0 ? false : true}
                                            />
                                            <div className="icon-container_list myList">
                                                {isSelectOpen === "Status" ? (
                                                    <IoCaretUpOutline />
                                                ) : (
                                                    <IoCaretDownOutline />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                        </div>

                        {(parseInt(UM_UserType) === 3 ||
                            (parseInt(UM_UserType) === 0 && selectedCompany?.value && selectedOption?.value === 3) ||
                            (parseInt(UM_UserType) === 1 && selectedOption?.value === 3)) &&
                            selectedScps.length > 0 && (
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        {renderLabel("DSCP", "Default SCP")}
                                        <div className="select-container_list">
                                            <ReactSelectDropDown
                                                name="DSCP"
                                                options={
                                                    scpOptions
                                                        .filter((scp) => selectedScps.includes(scp.SCPM_ID))
                                                        .map((scp) => ({ value: scp.SCPM_ID, label: scp.SCPM_Name }))
                                                }
                                                value={defaultScp?.value || ""}       // ReactSelectDropDown needs only value
                                                onChange={(e) => handleChange("DSCP", e.target.value)}
                                                placeholder="--Select--"
                                                idKey="value"
                                                displayKey="label"
                                                onMenuOpen={() => handleSelectOpen("DSCP")}
                                                onMenuClose={handleSelectClose}
                                                disabled={false}                      // no disable logic here (can add if required)
                                                enableScrollEffect={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        {(
                            parseInt(UM_UserType) === 2 ||
                            (parseInt(UM_UserType) === 0 && selectedCompany?.value && selectedOption?.value === 2) ||
                            (parseInt(UM_UserType) === 1 && selectedOption?.value === 2)
                        ) && (
                                <>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                {renderLabel("PName", "Plant Name")}
                                                <div className="form-check">

                                                    {plantOptions.length > 0 ? (
                                                        <>
                                                            {/* ✅ Show ALL */}
                                                            <div>
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="plant-all"
                                                                    checked={selectedPlants.length === plantOptions.length}
                                                                    onChange={(e) => handleSelectAllPlants(e.target.checked)}
                                                                />
                                                                <label htmlFor="plant-all" className="form-check-label">
                                                                    ALL
                                                                </label>
                                                            </div>

                                                            {/* ✅ Show plants list */}
                                                            {plantOptions.map((plant) => (
                                                                <div key={plant.plantId}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        id={`plant-${plant.plantId}`}
                                                                        value={plant.plantId}
                                                                        checked={selectedPlants.includes(plant.plantId)}
                                                                        onChange={() => handleChange('PName', plant.plantId)}
                                                                    />
                                                                    <label
                                                                        htmlFor={`plant-${plant.plantId}`}
                                                                        className="form-check-label"
                                                                    >
                                                                        {plant.plantName}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <p className="text-muted">No Plants To Select</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                {renderLabel("LName", "Line Name")}
                                                <div className="form-check">

                                                    {filteredLines.length > 0 ? (
                                                        <>
                                                            {/* ✅ Show ALL */}
                                                            <div>
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="line-all"
                                                                    checked={selectedLines.length === filteredLines.length}
                                                                    onChange={(e) => handleSelectAllLines(e.target.checked)}
                                                                />
                                                                <label htmlFor="line-all" className="form-check-label">
                                                                    ALL
                                                                </label>
                                                            </div>

                                                            {filteredLines.map((line) => {
                                                                // Find the plant name for this line

                                                                return (
                                                                    <div key={line.LM_LineID}>
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input"
                                                                            id={`line-${line.LM_LineID}`}
                                                                            value={line.LM_LineID}
                                                                            checked={selectedLines.includes(line.LM_LineID)}
                                                                            onChange={() => handleChange('LName', line.LM_LineID)}
                                                                        />
                                                                        <label
                                                                            htmlFor={`line-${line.LM_LineID}`}
                                                                            className="form-check-label"
                                                                        >
                                                                            {line.plantName} / {line.LM_LineName}
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })}
                                                        </>
                                                    ) : (
                                                        <p className="text-muted">No Lines To Select</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                        <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered>
                            <Modal.Body>
                                <div className="modalContainer">
                                    <h3
                                        style={{
                                            textAlign: "center",
                                            color: "#465a64",
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                            margin: "10px",
                                            marginTop: "20px",
                                            marginBottom: "10px",
                                        }}
                                    >
                                        :: Image Preview ::
                                    </h3>
                                    {imagePreview ? (
                                        <div style={{ textAlign: "center" }}>
                                            <img
                                                src={imagePreview}
                                                alt="Preview"
                                                style={{ maxWidth: '100%', maxHeight: '400px', objectFit: 'contain' }}
                                            />
                                        </div>
                                    ) : (
                                        <p style={{ textAlign: "center", color: "#465a64" }}>
                                            No image available
                                        </p>
                                    )}
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            marginTop: "15px",
                                        }}
                                    >
                                        <button
                                            className="ok_btn"
                                            onClick={() => setShowImageModal(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <Modal show={showModal} keyboard={false} onHide={() => setShowModal(false)} centered animation={false} style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
                            <Modal.Body>
                                <div className="modalContainer">
                                    <h3
                                        style={{
                                            textAlign: "center",
                                            color: "#465a64",
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                            margin: "10px",
                                            marginTop: "20px",
                                            marginBottom: "10px",
                                        }}
                                    >
                                        :: User Confirmation ::
                                    </h3>

                                    <p
                                        style={{
                                            textAlign: "center",
                                            marginTop: "10px",
                                            color: "#465a64",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        User {modalData.msg} successfully
                                    </p>
                                    <p
                                        style={{
                                            textAlign: "center",
                                            color: "#465a64",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Please note down below details to login.
                                    </p>

                                    <div
                                        style={{
                                            marginLeft: "145px",
                                            color: "#465a64",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                        }}
                                    >
                                        <div style={{ marginBottom: '6px' }}>
                                            <div style={{ display: "flex" }}>
                                                <span style={{ width: "100px", flexShrink: 0 }}>User Name :</span>
                                                <span
                                                    style={{
                                                        wordBreak: "break-word",
                                                        whiteSpace: "pre-wrap",
                                                        userSelect: "text",
                                                    }}
                                                >
                                                    {modalData.user}
                                                </span>
                                            </div>
                                        </div>

                                        <div>
                                            <div style={{ display: "flex" }}>
                                                <span style={{ width: "100px", flexShrink: 0 }}>Password&ensp;&ensp;:</span>
                                                <span
                                                    style={{
                                                        wordBreak: "break-word",
                                                        whiteSpace: "pre-wrap",
                                                        userSelect: "text",
                                                    }}
                                                >
                                                    {modalData.password}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            marginTop: "5px",
                                        }}
                                    >
                                        <button
                                            className="ok_btn"
                                            onClick={() => {
                                                // resetUserForm();
                                                setShowModal(false);
                                            }}
                                        >
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>
            <div className="button-container">
                <button className="save_btn" type="button" onClick={handleSave}>SAVE</button>
                <button className="reset_btn" type="button" onClick={handleReset}>RESET</button>
                <Link to={`/umlist`} className="list_btn" type="button">LIST</Link>
            </div>
        </>
    );
}

export default UserMaster;
